<app-leveltwo [pageName]="'Chruch Exemption'">
  <div class="General">

    <h3>{{'Church.PageTitle'|translate}}</h3>
      <!--
      <p>{{'Church.Theseexemptions'|translate}}<b> {{'Church.213'|translate}}</b> {{'Church.oremailed'|translate}} <a href="mailto:exempt@assessor.lacounty.gov">{{'Church.exempt'|translate}}</a></p>

      <p>{{'Church.Churchexemption'|translate}}<a href="https://leginfo.legislature.ca.gov/faces/codes_displayText.xhtml?lawCode=CONS&division=&title=&part=&chapter=&article=XIII" target="_blank">{{'Church.section3f'|translate}}</a> {{'Church.asimplemented'|translate}} <a href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=206.&lawCode=RTC" target="_blank">{{'Church.section206'|translate}}</a></p>
      <p>{{'Church.Thechurch'|translate}}</p>
      -->
    <h4>{{'Church.ChurchExemption'|translate}}</h4>
    <p>{{'Church.ChurchExDesc'|translate}}</p>
    <h4>{{'Church.ReligiousExemption'|translate}}</h4>
    <p>{{'Church.ReligiousExDesc'|translate}}</p>

    <p [innerHTML]="'Church.Formore'|translate"></p>
    <!-- {{'Church.MajorExemp'|translate}}<br><br>

    {{'Church.Phone'|translate}}: <b>(213) 974-3481</b><br>
    {{'Church.Email'|translate}}: <a href="mailto:exempt@assessor.lacounty.gov">exempt@assessor.lacounty.gov</a>

    Major Exemption<br>
    {{'Church.Phone'|translate}}: <b>(213) 974-3481</b><br>
    {{'Church.Email'|translate}}: <a href="mailto:exempt@assessor.lacounty.gov">exempt@assessor.lacounty.gov</a> -->
  </div>
</app-leveltwo>
